/*常量定义*/
const myConst = {
    headToken: 'authorization',  //请求头中token属性名
    keyStore: "store",  //刷新保存状态key
    keyToken: "token",  //存储token,key
    keyButtonList: "buttonList",  //权限按钮存储key
    keyRouterList: "routerList", //路由存储key
    keyIntegrSysMenuList: "integrSys", //综合系统菜单储存key
    keyEnergyStorageSysMenuList: "energyStorageSys", //储能系统菜单存储key
    keyPhotovoltaicSysMenuList: "photovoltaicSys", //光伏系统存储key
    keyBtnList:'perButton', //权限按钮的存储key
    keyPerStationList:"perStatList", //权限电站列表

    code: {  //服务端正常情况返回状态码
        success: 200, // 成功
        fail: 400, // 失败
        forbidden: 403, // 拒绝
        error: 500, // 异常
        logged: 201, // 用户已登录
        logout: 401, // 凭证无效，登出
    },
    logged: {  //是否强制登录状态参数
        default: 0,  //默认正常登录
        mandatory: 1  //强制登录
    },
    menuLevel: {  //菜单级别
        one: 0,  //一级
        two: 1,  //二级
        three: 2  //三级
    },
    menuSign: {  //菜单标记
        pri: 0,//私有菜单
        pub: 1,//公有菜单
    },
    menuType: {  //菜单类型
        directory: 0,  //目录
        menu: 1,  //菜单
        messBoxMenu: 2,  //弹窗菜单
        openPageMenu: 3  //打开新页菜单
    },
    menuDefShow: {  //菜单默认加载显示状态
        yes: 0,  //显示
        no: 1   //隐藏
    },
    enableSign: {  //生效标记
        yes: 0,  //生效
        no: 1  //不生效
    },
    stationState: {  //电站状态
        state0: 0,//建设
        state1: 1,//投运
        state2: 2,//暂停
        state3: 3,//停用
    },
    historySign: {  //设备历史数据存储标记
        no: 0,  //不存储
        yes: 1,  //存储
    },
    chartRelationType: {  //图表和图表数据类型
        sta: 0,  //电站
        dev: 1,  //设备
        other: 2,  //其他
    },
    alterSign: {  //修改标记
        yes: 0,  //可修改
        no: 1  //不可修改
    },
    deleteSign: {  //删除标记
        yes: 0,  //可删除
        no: 1  //不可删除
    },
    contrastType: {  //数据对比数据类型，瞬时值，累计量
        instant: 0,  //瞬时值
        cumulative: 1,  //累计量
    },
    controlInputForm: { //控制窗口数据输入格式
        text: 0,//文本框形式
        btn: 1, //按钮形式
        select: 2, //下拉列表
    },
    chartType: {  //图表类型
        sta: 0,
        dev: 1,
        other: 2
    },
    menuCode: {   //弹出菜单唯一码
        ctrlCode: "int:mon:sys:ctrl",  //控制窗唯一码
        alarmCode: "int:mon:sta:alarm",  //告警窗唯一码
    },
    stateSign: {  //点表数据点状态标记
        unlabeled: 0, //未标记
        alarmState: 1, //告警状态
        alarmCode: 2, //告警码
        alarmStateCode: 3, //告警状态码
        stateCode: 4, //状态码
        stateQuantity: 5, //状态量
    },
    displayForm: { //点表数据点显示形式
        text: 0, //文本形式
        switch: 1, //开关形式
        stateQuantity: 2, //状态量
        stateCard: 3, //状态牌
        alarmCard: 4, //告警牌
    },
    dataLoadWay: {  //实时数据加载方式
        real: 0, //实时推送
        hisData: 1, //扫描历史表
    },
    dataType: { //点表数据类型
        integer: 0, //整数
        floatPonint: 1, //浮点数
        string: 2, //字符串
        date: 3, //时间日期
    },
    modelType: { //模块类型
        grid: 1, //并网点模块
        allData: 2, //全局数据模块
        realData: 3, //实时工作参数模块
        oneDevData: 4, //单设备数据模块
        cumulantData: 5, //累计量数据模块
    },
    cumulateType: { //累积量类型
        hour: 1, //时
        day: 2, //日
        month: 3, //月
        year: 4, //年
        sumUp: 5, //总
    },
    sourceType: { //源类型
        devData: 1, //设备数据
        instantData: 2, //瞬时量数据
        cumulateData: 3 ,//累积量数据
        staticInfo: 4, //静态信息
        configInfo: 5, //配置信息
        devPointTable:6, //设备点表
    },
    // 设备状态规则数据类型
    devStateRule: {
        dataKey:0,//数据Key
        dataBit:1,//数据bit码
    },
    stationInfo: { //电站的静态信息
        infoCode1: "esCapacity",//储能容量
        infoCode2: "esPower", //储能功率
        infoCode3: "pvPower", //光伏容量
        infoCode4: "anzhuangNL", //安装容量
    },
    sysType: { //系统类型
        integratedSys: 1, //综合系统
        energyStorageSys: 2,//储能系统
        photovoltaicSys: 3, //光伏系统
    },
    confirmState: {
        confirm: 1, //已确认
        noConfirm: 0 //未确认
    },
    secretKey: { //第三方秘钥
        key: "NlASxF4/9GJYT2Q0MghUwQ=="
    },
    dicType: {  //数据字典类型码
        //通用
        showState: "show:state",  //显示状态，0显示，1不显示
        historySign: "history:sign",  //历史存储标记
        alterSign: "alter:sign",
        delSign: "del:sign",
        enableSign: "enable:sign",

        //用户模块
        userState: "user:state",
        onlineState: "online:state",//在线状态

        //角色模块
        roleSign: "role:sign",

        companyState: "company:state",
        companyType: "company:type",

        staType: "sta:type",
        staState: "sta:state",
        staCommWay: "sys:comm:way",  //系统通讯方式
        staDataLoadWay: "sys:data:load:way",  //系统数据加载方式
        staMenuConfigState: "sys:menu:state",  //系统菜单关联状态

        devSysType: "dev:sys:type",  //设备系统类型
        devType: "dev:type",  //设备类型
        meterSign: "meter:sign",  //电表标记
        devDataSign: "dev:data:sign",  //设备上下下限数据标记
        devState: "dev:state",  //设备状态

        ptDataSign: "pt:data:sign",  //点表数据点数据标记
        ptDataType: "pt:data:type",  //点表数据点数据类型
        ptAlarmSign: "pt:alarm:sign",  //点表数据点告警标记
        ptUnit: "pt:unit",  //点表数据单位
        ptDecimalLength: "pt:dec:len",  //点表小数位长度
        ptAlarmLevel: "pt:alarm:level",  //点表告警码级别

        dtDataSign: "dt:data:sign",  //数据表数据标记
        dtStateSign: "dt:state:sign", //数据表状态标记

        chartRelationType: "chart:relation:type",  //图表关联类型

        chartDataLoadWay: "chart:data:load:way",  //图表数据加载方式
        chartDataDataType: "chart:data:data:type",  //图表数据数据类型
    },
    reg: {
        code: "[\\\u4E00-\\\u9FFF]+",  //汉子检测，前后不可以加结束符
        longitude: "^(\\-|\\+)?(((\\d|[1-9]\\d|1[0-7]\\d|0{1,3})\\.\\d{0,6})|(\\d|[1-9]\\d|1[0-7]\\d|0{1,3})|180\\.0{0,6}|180)$",//经度
        latitude: "^(\\-|\\+)?([0-8]?\\d{1}\\.\\d{0,6}|90\\.0{0,6}|[0-8]?\\d{1}|90)$", //纬度
        decimal: "^(-?\\d+)(\\.\\d+)?$",  //验证是数字
        positiveInt: "^\\d+$",  //正整数
    },
    chartInfoCode: { //储能图表类型码
        grid: "globalChart1", //并网点功率曲线
        power: "globalChart2", //功率曲线
        charge: "globalChart3", //充放电量柱状图
        sendUse: "globalChart4", //发用电量柱状图
        earnings: "globalChart5", //收益统计
    },
    staModelType: { //电站模块类型
        default:0, //默认,不标记
        sysOverChart1:1, //系统总览
        emsChart2:2, //EMS并网点功率曲线
        emsChart3:3, //EMS系统功率曲线
        emsChart4:4, //EMS-充放电量柱状图
        emsChart5:5, //EMS-发用电量柱状图
        emsChart6:6, //EMS-收益统计
        
        emsChart100:100, //EMS-综合概览-发用电功率曲线图
        emsChart101:101, //EMS-综合概览-发用电量柱状图
        emsChart102:102, //EMS-综合概览-碳排统计

        emsChart103:103, //EMS-光伏系统-发用电功率曲线图
        emsChart104:104, //EMS-光伏系统-发用电量柱状图
        emsChart105:105, //EMS-光伏系统-碳排统计

        emsChart106:106, //EMS-储能系统-功率曲线
        emsChart107:107, //EMS-储能系统-发用电量柱状图
        emsChart108:108, //EMS-储能系统-收益柱状图

        emsChart109:109, //EMS-柴发系统-发电量柱状图
        emsChart110:110, //EMS-柴发系统-碳排统计

        emsChart111:111, //EMS-微网系统-功率曲线
        emsChart112:112, //EMS-微网系统-充放电量柱状图
        emsChart113:113, //EMS-微网系统-发用电量柱状图

        emsChart114:114, //EMS-水电站-发电量柱状图
        emsChart115:115, //EMS-水电站-功率曲线图

        emsChart116:116, //EMS-充电桩-功率曲线图
        emsChart117:117, //EMS-充电桩-充用电量柱状图
        emsChart118:118, //EMS-充电桩-收益柱状图

        emsChart119:119, //EMS-负荷系统-功率曲线图
        emsChart120:120, //EMS-负荷系统-用电量柱状图
        emsChart121:121, //EMS-负荷系统-费用柱状图
    },
    devModelType:{ //设备模块类型
        default: 0, //不标记,默认值
        devDetail: 1, //设备详情
    },
    //EMS图表的电站模块标记
    staModuleSign: {
        default: 0, //默认,不标记
        sysOverview: 1, //系统总览
        girdSuppPoint:2, //并网点功率曲线

    },
    chartype: { //曲线图类型
        pictorialBarChart: "pictorialBar", //象形条图
    },
    companyInfoCode: { //单位静态信息码
        nameKey1: 'iemsName', //综合能源系统名称
        nameKey2: 'emsName', //储能EMS名称
        nameKey3: 'iemsImg', //综合能源系统图片
        nameKey4: 'emsImg', //储能EMS图片
    },

    // 详情页面显示类型
    detailType:{
        text: 1, //文本
        textarea:2, //多行文本
        time:3, //时间
        image:4, //图片
    },
    universalModuleType:{ //通用的模块标记
        stat:0, //电站
        dev:1, //设备
        control:2, //控制器
    },
    imgModuleSign:{  //图片的模块标记
        statCar:1, //电站-电站卡片
        statSysOver:2, //电站- 系统总览
        statInfo:3, //电站-静态信息
        statDevCar:4, //电站-设备卡片
        devGeneral:5, //设备-设备概况
        devInfo:6, //设备-设备信息
        EMSImg7:7, //电站-综合概况
        EMSImg8:8, //电站-微网系统
        EMSImg9:9, //电站-水电站
        EMSImg10:10, //电站-光伏系统
        EMSImg11:11, //电站-储能系统
        EMSImg12:12, //电站-柴发系统
        EMSImg13:13, //电站-充电桩
        EMSImg14:14, //电站-负荷系统
        EMSImg15:15, //电站-综合概况(旧页面)
    },
    dataModuleSign:{ //数据的模块标记
        statCar:1, //电站-电站卡片
        statSysOver:2, //电站- 系统总览
        statInfo:3, //电站-静态信息
        statDevCar:4, //电站-设备卡片
        devGeneral:5, //设备-设备概况
        devInfo:6, //设备-设备信息
        
        EMSSynthesisIntroduce:100, //EMS-综合概览-项目介绍
        EMSSynthesisElectricity:101, //EMS-综合概览-用电量排行
        EMSSynthesisGenerateElectricity:102, //EMS-综合概览-发用电量柱状图
        EMSSynthesisSituation:103, //EMS-综合概览-全局变量

        EMSLightIntroduce:104, //EMS-光伏系统-项目介绍
        EMSLightRunTime:105,// EMS-光伏系统-运行时态
        EMSLightEarnings:106,// EMS-光伏系统-收益统计
        EMSLightOverallSituation:107,// EMS-光伏系统-全局变量

        EMSStoredEnergyRunTime:108, //EMS-储能系统-运行时态
        EMSStoredEnergyChargeDischarge:109, //EMS-储能系统-充放电量统计
        EMSStoredEnergyOverallSituation:110, //EMS-储能系统-全局变量
        EMSStoredEnergyIntroduce:111, //EMS-储能系统-项目介绍

        EMSMicrogridIntroduce:128, //EMS-微网系统-项目介绍
        EMSMicrogridGatewayMeter:129, //EMS-微网系统-关口表
        EMSMicrogridAccumulate:130, //EMS-微网系统-累积量统计
        EMSMicrogridOverallSituation:132, //EMS-微网系统-全局变量
        EMSMicrogridRealTime:133, //EMS-微网系统-实时工作参数-总览
        EMSMicrogridRealTimePower:8, //EMS-微网系统-实时工作参数-设备下拉

        EMSHyropowerStationIntroduce:112, //EMS-水电站-项目介绍
        EMSHyropowerStationEquipment:114, //EMS-水电站-设备参数
        EMSHyropowerStationGatewayMeter:113, //EMS-水电站-关口表
        EMSHyropowerStationOverallSituation:115, //EMS-水电站-全局变量

        EMSFaggotIntroduce:124, //EMS-柴发系统-项目介绍
        EMSFaggotGatewayMeter:126, //EMS-柴发系统-关口表
        EMSFaggotIntroduceOilConsumption:125, //EMS-柴发系统-设备参数
        EMSFaggotOverallSituation:127, //EMS-柴发系统-全局变量

        EMSChargingPileIntroduce:116, //EMS-充电桩-项目介绍
        EMSChargingPileRunTime:117, //EMS-充电桩-运行时态
        EMSChargingPileChargeDischarge:118, //EMS-充电桩-充放电量统计
        EMSChargingPileOverallSituation:119, //EMS-充电桩-全局变量

        EMSLoadIntroduce:120, //EMS-负荷系统-项目介绍
        EMSLoadRunTime:121, //EMS-负荷系统-运行时态
        EMSLoadElectricity:122, //EMS-负荷系统-用电量排行
        EMSLoadOverallSituation:123 //EMS-负荷系统-全局变量
    },
    simulateDataConfigType:{ //模拟数据配置类型
        dev:"0", //设备
        pt:"1", //点表
    },
    simulateType:{ //模拟点规则的模拟类型
        fixedVal:"0", //固定值
        randomNum:"1", //随机数
        cumulant:"2", //累积量
        exportPoint:"3", //导入点
    },
    devDetailRouteCode:'int:mon:dev:det', //设备详情菜单码
    iemsRoute:"/iems", //IEMS详情菜单码
    topoType: { //拓扑图类型码
        type0: "0", //主拓扑结构页面
        type1: "1", //系统总览页面拓扑
        type2: "2", //预置图扑图一
        type3: "3", //预置图扑图二
        type4: "4", //预置图扑图三
        type5:"100", //EMS-综合概览拓扑
        type6:"109", //EMS-微网系统场景拓扑
        type7:"101", //EMS-微网系统拓扑
        type8:"102", //EMS-水电站拓扑
        type9:"103", //EMS-光伏系统拓扑
        type10:"104", //EMS-储能系统拓扑
        type11:"105", //EMS-柴发系统拓扑
        type12:"106", //EMS-充电桩拓扑
        type13:"107", //EMS-负荷系统拓扑
        type14:"116", //EMS场景图连线代码
    },
    staTopoModelSign: { //拓扑图类型码
        sign1: "1", //主拓扑结构页面
        sign2: "2", //预置图扑图一
        sign3: "3", //预置图扑图二
        sign4: "4", //预置图扑图三
        sign5:"100", //EMS-综合概览拓扑
        sign6:"109", //EMS-微网系统场景拓扑
        sign7:"101", //EMS-微网系统拓扑
        sign8:"102", //EMS-水电站拓扑
        sign9:"103", //EMS-光伏系统拓扑
        sign10:"104", //EMS-储能系统拓扑
        sign11:"105", //EMS-柴发系统拓扑
        sign12:"106", //EMS-充电桩拓扑
        sign13:"107", //EMS-负荷系统拓扑
        sign14:"116", //EMS场景图连线代码
    },
    devTopoModelSign: {
        
    },

    emsWeatherSign: {
        disable:'0', //不启动
        enable:'1', //启动
    },

    shareSign:{
        noSet: 0, //不设置
        statShare: 1, //电站分享
        devShare: 2, //设备分享
        ptShare: 3, //点表共享
    },
    chartBelongType:{
        stat:"0",
        dev:"1"
    }
}

export default myConst
